import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['checkBox']

  selectAll(event) {
    let selected = event.target.checked;

    this.checkBoxTargets.map(record => record.checked = selected);
  }
}
